var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUploadCloudBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1593_4435",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1593_4435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.875 15C3.7375 15 2.76575 14.6062 1.95975 13.8187C1.15325 13.0312 0.75 12.0687 0.75 10.9312C0.75 9.95625 1.04375 9.0875 1.63125 8.325C2.21875 7.5625 2.9875 7.075 3.9375 6.8625C4.25 5.7125 4.875 4.78125 5.8125 4.06875C6.75 3.35625 7.8125 3 9 3C10.4625 3 11.703 3.50925 12.7215 4.52775C13.7405 5.54675 14.25 6.7875 14.25 8.25C15.1125 8.35 15.8283 8.72175 16.3973 9.36525C16.9657 10.0093 17.25 10.7625 17.25 11.625C17.25 12.5625 16.922 13.3595 16.266 14.016C15.6095 14.672 14.8125 15 13.875 15H9.75C9.3375 15 8.9845 14.8533 8.691 14.5597C8.397 14.2657 8.25 13.9125 8.25 13.5V9.6375L7.05 10.8L6 9.75L9 6.75L12 9.75L10.95 10.8L9.75 9.6375V13.5H13.875C14.4 13.5 14.8438 13.3187 15.2062 12.9562C15.5687 12.5938 15.75 12.15 15.75 11.625C15.75 11.1 15.5687 10.6563 15.2062 10.2938C14.8438 9.93125 14.4 9.75 13.875 9.75H12.75V8.25C12.75 7.2125 12.3845 6.328 11.6535 5.5965C10.922 4.8655 10.0375 4.5 9 4.5C7.9625 4.5 7.07825 4.8655 6.34725 5.5965C5.61575 6.328 5.25 7.2125 5.25 8.25H4.875C4.15 8.25 3.53125 8.50625 3.01875 9.01875C2.50625 9.53125 2.25 10.15 2.25 10.875C2.25 11.6 2.50625 12.2188 3.01875 12.7313C3.53125 13.2438 4.15 13.5 4.875 13.5H6.75V15H4.875Z",
    fill: "#00BCE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUploadCloudBlue);
export default __webpack_public_path__ + "static/media/ic-upload-cloud-blue.67efcf7e536d138a84caffbb878ea29a.svg";
export { ForwardRef as ReactComponent };